<template>
  <v-row class="px-6">
    <v-col cols="12" md="2">
      <v-text-field
        @input="searchFunc"
        v-model="filterData.search"
        clearable
        class="rounded-lg pr-0 sm-font400-14"
        append-icon="mdi-magnify"
        label="جستجو"
        hide-details
        outlined
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        :items="courseStatusItems"
        @input="searchFunc"
        v-model="filterData.is_active"
        class="rounded-lg sm-font400-14"
        label="وضعیت دوره"
        item-text="title"
        item-value="id"
        hide-details
        clearable
        outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        :items="courseType"
        @input="searchFunc"
        v-model="filterData.course_type"
        class="rounded-lg sm-font400-14"
        label="نوع دوره"
        item-text="text"
        item-value="id"
        hide-details
        clearable
        outlined
      ></v-select>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        :items="teachers"
        @input="searchFunc"
        v-model="filterData.teacher_id"
        class="rounded-lg sm-font400-14"
        label="نام مربی"
        item-text="title"
        item-value="id"
        hide-details
        clearable
        outlined
      ></v-select>
    </v-col>

    <v-col cols="12" md="2">
      <v-btn
        block
        color="primary"
        @click="showMultipleAction = true"
        class="white--text rounded-lg sm-font400-13"
        elevation="0"
        height="56"
        :disabled="ids.length === 0"
      >فعال و غیرفعال کردن
      </v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-btn
        block
        color="positive"
        @click="initialCourse = true"
        class="white--text rounded-lg sm-font400-13"
        elevation="0"
        height="56"
      >افزودن دوره مادر
      </v-btn>
    </v-col>

    <v-col cols="12" md="2">
      <v-btn
        block
        outlined
        @click="exportExcel"
        class="thirdColor--text rounded-lg sm-font400-13"
        height="56"
      >
        <v-icon>mdi-upload</v-icon>
        خروجی اکسل
      </v-btn>
    </v-col>

    <v-dialog v-model="showMultipleAction" width="500" @click:outside="clearList">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از فعال/غیرفعال کردن دوره ها مطمئن
          هستید؟</h3>
        <v-btn :loading="loadingBunchStatus" @click="bunchActionStatus" block color="positive" class="white--text rounded-xl mt-3"
               height="48">ارسال
        </v-btn>
      </v-card>
    </v-dialog>


    <v-dialog v-model="initialCourse" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <div class="d-flex mb-7">
          <!--          <v-icon class="me-3">mdi-arrow-right</v-icon>-->
          <p class="mb-0 sm-font600-16 textColorSecond--text">نوع دوره مادر را مشخص کنید</p>
        </div>
        <div>
          <v-radio-group v-model="selectedCourse">
            <div v-for="(item, index) in courseType" :key="item.id">
              <div class="d-flex align-center">
                <v-radio
                  inset
                  :value="item.id"
                  class="mb-0 me-5"
                  color="thirdColor"
                ></v-radio>
                <label class="sm-font400-14 primary--text">{{ item.text }}</label>
              </div>
              <v-divider class="my-4" v-if="index < courseType.length -1"/>
            </div>
          </v-radio-group>
        </div>
        <v-btn @click="initialCourse = false" elevation="0"
               class="black--text border rounded-lg mt-3 me-4" height="32">بازگشت
        </v-btn>
        <v-btn :loading="loading" elevation="0" @click="gotoForm" color="secondary"
               class="white--text rounded-lg mt-3" height="32">ادامه
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import courseApi from "@/Services/modules/courses"
import reports from "@/Services/modules/reports"

export default {
  name: "filter-page",
  props: {
    ids: {
      type: Array
    },
    filterSearch: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      loadingBunchStatus: false,
      courseStatusItems: [{id: true, title: "فعال"}, {id: false, title: "غیرفعال"}],
      categoryList: [],
      teachers: [],
      showMultipleAction: false,
      initialCourse: false,
      filterData: {
        page: Number(this.filterSearch.page) || Number(this.$route.query.page) || 1,
        search: this.filterSearch.search || this.$route.query.search || "",
        is_active: this.filterSearch.is_active,
        course_type: this.filterSearch.course_type,
        teacher_id: this.filterSearch.teacher_id || null,
        is_archive: false
      },
      courseType: null,
      selectedCourse: null,
    }
  },
  mounted() {
    this.courseType = [
      {
        id: "Online",
        text: "کوچینگ"
      },
      {
        id: "Offline",
        text: "بوت کمپ"
      },
      {
        id: "Online_Offline",
        text: "دوره تکمیلی"
      },
    ]
    this.getAllCategories()
    this.getTeachers()
  },
  methods: {
    getAllCategories() {
      courseApi.getAllCategory().then(res => {
        this.categoryList = res.data.results
      })
    },
    getTeachers() {
      reports.getTeachers().then((res) => {
        this.teachers = (res.data.results || []).map((teacher) => ({
          id: teacher.id,
          title: `${teacher.first_name} ${teacher.last_name}`.trim(),
        }))
      })
    },
    searchFunc() {
      this.filterData.page = 1
      this.$emit("getData", this.filterData)
    },
    clearList() {
      this.$emit("clearIdList")
    },
    bunchActionStatus() {
      this.loadingBunchStatus = true
      courseApi.multipleStatusActionOnBaseCourse({ids: this.ids, is_active: true}).finally(() => {
        this.showMultipleAction = false
        this.$emit("getData", this.filterData)
      }).finally(()=> {
        this.loadingBunchStatus = false
      })
    },
    gotoForm() {
      switch (this.selectedCourse) {
        case 'Online' :
          this.$router.push('/courses/coaching/create');
          break;
        case 'Offline' :
          this.$router.push('/courses/bootcamp/create');
          break;
        case 'Online_Offline':
          this.$router.push('/courses/additionalCrs/create');
          break;
        default:
          break;
      }
    },
    exportExcel() {
      courseApi.getExcel(this.filterData).then((response) => {
        window.open(URL.createObjectURL(response.data));
      })
    }
  }
}
</script>

<style scoped>

</style>
